<div class="report-widget">
  @if (isOpen) {
    <div class="panel">
      <div style="display: flex; gap: 8px">
        <h3>{{ 'report' | transloco }}</h3>
        <span
          class="help-icon"
          [attr.data-tooltip]="'report_desc' | transloco"
          >
          ?
        </span>
      </div>
      <app-attachments
        [(ngModel)]="report"
        [placeholder]="'report_placeholder' | transloco"
        [fileTypes]="['image/png', 'image/jpeg', 'image/jpg']"
        (setModal)="setModal($event)"
      ></app-attachments>
      <div class="controls">
        @if (isOpen) {
          <button
            class="ui button background primary {{!report.message.trim() ? 'disabled' : ''}}"
            (click)="submit()"
            [disabled]="!report.message.trim()"
            >
            {{ 'send' | transloco }}
          </button>
        }
        <div class="ui button go-back cancel"  (click)="toggle()">
          {{ 'close'| transloco }}
        </div>
      </div>
    </div>
  }

  <div class="report-button"  (click)="toggle()">
    {{ 'report' | transloco }}
  </div>
</div>

@if (modalImgSrc) {
  <div class="modal-backdrop" (click)="setModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <img [src]="modalImgSrc" />
    </div>
  </div>
}
